module.exports = __webpack_public_path__ + "static/a6-99e6e64a17c9d164b36d97296c9ef9b1.png";